import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SearchService } from '../../../../search/services/search/search.service';
import { UserService } from 'src/app/feature/user/services/user.service';
import { SharedService } from 'src/app/shared/services/shared/shared.service';
import { CommonService } from 'src/app/shared/services/common/common.service';
import { config } from 'src/assets/config/config';
import { Country } from 'src/app/shared/country.type';


@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit, OnDestroy {

  public searchedKeyword: any;
  public allSearchedData: any;
  public serverError = false;
  private unsubscribe$ = new Subject();
  public allSearchResults: any;
  public correctedKeyword: any;
  public showMoreData: any;
  public showMore = false;
  public splittedKeywords = [];
  private _currentPopover: any;
  @ViewChildren(PopoverDirective) popovers: QueryList<PopoverDirective>;
  public allResults: any;
  public correctedWord: string;
  private currentLang: any
  languageSubscription: Subscription;
  private storedQueryParams: Params = {};
  public articlePreview: boolean;


  constructor(
    private route: ActivatedRoute,
    private searchService: SearchService,
    private router: Router,
    private uService: UserService,
    private sharedService: SharedService,
    private commonService: CommonService,
    private ngxService: NgxUiLoaderService) {
    this.route?.queryParams?.subscribe(
      (params: Params) => {
        if (this.router.url.indexOf('/search/search-results') > -1) {
          this.searchedKeyword = params['keyword'];
          this.splittedKeywords = this.searchedKeyword.split(" "); 
          this.getAllSearchTask(this.searchedKeyword);
         if (Object.keys(params).length > 0) {
        this.storedQueryParams = { ...params };  // Store the query params
      }
        }
      }
    )
  }

  ngOnInit(): void {
    this.searchedKeyword = this.route?.snapshot?.queryParamMap?.get('keyword');
    this.languageSubscription = this.commonService.language$.subscribe(lang => {
      this.currentLang = lang;
      this.preserveQueryParamsOnLangChange();
    })
    //  // for GA
     this.uService.emitEvent(this.searchedKeyword, "Searched Keyword", "SearchSuccess", 8);
    //  // for GA
    this.getAllSearchTask(this.searchedKeyword);
		let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
    this.articlePreview = config[country]?.search?.articlePreview;
    
  }

  /**
 * Method to preserve query parameters when the language is switched
 */
  preserveQueryParamsOnLangChange(): void {
		let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
      const langParam = this.sharedService.getDefaultCountry();
      const path = `/${config[country]?.region}/search/search-results`;
      this.router.navigate([path], { queryParams: this.storedQueryParams });
  }

  public closeOldPopover(popover: any): void {
    if (this._currentPopover && this._currentPopover !== popover) {
      this._currentPopover.hide();
    }
  
    this._currentPopover = popover;
  }

  /**
   * @description Method to get all search data from API
   */
  public getAllSearchTask(keyword: string): void {
    this.ngxService.start();
    this.searchService.getAllSearchData(keyword)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((resp) => {
        if (resp) {
          this.ngxService.stop();
          this.allSearchedData = resp;
          this.getCorrectedKeyword();
          const countryId = this.commonService.getCountryId();
          let userType = sessionStorage.getItem('userType');
          this.allSearchResults = (userType) ? (resp.searchRecords.filter((data:any) => {
            return (data?.UserType === userType || data?.UserType == null || data?.UserType.split(',').includes(userType))
          })) : resp.searchRecords;
          this.allResults = (userType) ? (resp.searchRecords.filter((data:any) => {
            return (data?.UserType === userType || data?.UserType == null || data?.UserType.split(',').includes(userType))
          })) : resp.searchRecords;
          this.allResults = this.allResults?.map((item: any) => {
            item['highlight.Title'] = item['highlight.Title']?.replaceAll("&lt;", "<").replaceAll("&gt;", ">")
              .replaceAll("&#x2F;", "/").replaceAll("&amp;reg;", "®");
            return item;
          });
          this.allSearchResults = this.allResults;
          this.allSearchResults = this.allSearchResults?.slice(0, 30);
          this.serverError = (this.allSearchResults.length == 0) ? true : false;
          this.showMore = this.allSearchedData?.searchRecords?.length > 30 ? true : false;
          this.showMoreData = resp.searchRecords?.slice(0, 50);
          this.searchService.emitData({ data: true });
        }
      },
        (err) => {
          this.ngxService.stop();
          if (err?.error?.StatusCode === "500") {
            this.serverError = true;
          } else if(err?.status == "400") {
              const langParam = this.sharedService.getDefaultCountry();
              let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
              const path =  `/${config[country]?.region}/search/common-keywords`;
              const currentTimeInSeconds = Math.floor(Date.now() / 1000); //unix timestamp in seconds
              this.router.navigate([path],
                { queryParams: { keyword: err?.error?.keyword, id: currentTimeInSeconds } });
            
          }
        });
  }

  /**
   * Method to show more search results
   */
  public showMoreContent(): void {
    this.allSearchResults = this.showMoreData;
    this.showMore = this.allSearchResults?.length > 30 ? false : true;
  }

  /**
   * Method to redirect to content page
   * @param title selected title
   */
  public redirectTitle(title: string): void {
    const langParam = this.sharedService.getDefaultCountry();
		let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
		const path = `/${config[country]?.region}/search/article-content`;
    this.getCorrectedKeyword();
    const keywordSearched = this.correctedKeyword ? this.correctedKeyword : this.searchedKeyword;
    const keyword = keywordSearched;
    const currentTimeInSeconds = Math.floor(Date.now() / 1000); //unix timestamp in seconds
    this.router.navigate([path],
      { queryParams: { keyword: keyword, title: title, id: currentTimeInSeconds } });
  }

  /**
   * Method to get the corrected keyword
   */
  public getCorrectedKeyword(): void {
    this.correctedKeyword = "";
    this.correctedWord = this.allSearchedData?.metadata?.entityMetadata[0]?.spellCorrectionMetadata?.correctedQuery;
    if (this.allSearchedData?.metadata && this.correctedWord) {
      this.correctedKeyword = this.correctedWord ? this.correctedWord : "";
    }
  }

   /**
      * Unsubscribe the Observable
      */
   public ngOnDestroy (): void {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

}
